import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  loading: Subject<any> = new Subject<any>();
  constructor() {
    /**/
  }

  /**
   * @method showSpinner for showing loader
   * @param showText is loader text as string
   */
  public showSpinner(showText?: string) {
    const data: any = [];
    data.text = showText;
    data.isLoad = true;
    this.loading.next(data);
  }

  /**
   * @method hideSpinner for hiding loader
   */
  public hideSpinner() {
    this.loading.next(false);
  }
}
